import React from "react"
import FontAwesome from "react-fontawesome"
import { fonts } from "./fontAwesome"

export default function Test() {

  return (
    <div className="p-10">
      <h2>Font Awesome</h2>
      <div className="flex-row flex-wrap">
        { fonts.map(font => <p key={font} className="m-10">
          <FontAwesome name={ font } size="lg" /><br/>
          <span>{ font }</span>
        </p>)}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/App/Test.js